module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-language-selector u-fixed u-pos-l-0 u-zindex--2 u-flex u-flex-jc--center u-fit-vw"
  }, [_c('div', {
    staticClass: "c-language-selector__container u-relative u-marg-x-auto u-flex u-flex-jc--end u-w8of10"
  }, [_c('div', {
    staticClass: "u-relative u-flex"
  }, [_vm._l((_vm.$root.content.global.langsAvailable), function(language, index) {
    return _c('div', {
      staticClass: "c-language_selector__item u-marg-l-xs",
      class: [index === 0 ? 'is-first' : '', _vm.$root.lang === language ? 'is-active' : 'is-inactive']
    }, [_c('a', {
      staticClass: "u-relative u-click-area-xxs t-link",
      attrs: {
        "href": _vm.$root.changeLang(language)
      }
    }, [_c('span', {
      staticClass: "t-text--xxxs u-uppercase",
      domProps: {
        "innerHTML": _vm._s(language)
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-language-selector__separator u-absolute u-pos-center u-bg--black-near"
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06afa328"}!./src/scripts/components/app-language-selector/template.html
// module id = 186
// module chunks = 0